import { render, staticRenderFns } from "./tobSettlement.vue?vue&type=template&id=50847761&scoped=true&"
import script from "./tobSettlement.vue?vue&type=script&lang=js&"
export * from "./tobSettlement.vue?vue&type=script&lang=js&"
import style0 from "./tobSettlement.vue?vue&type=style&index=0&id=50847761&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50847761",
  null
  
)

export default component.exports